import { FC } from "react"

type Props = {
  colSpan: number
  isLoading: boolean
  noMatchText?: string
}

export const TableLoadingRow: FC<Props> = ({colSpan, isLoading, noMatchText = 'No matching records found.'}) => {
  return (
  <tr>
    <td colSpan={colSpan}>
    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
      { isLoading ? (
      <span className="text-muted fw-light">
        Loading
        &nbsp;&#8230;&nbsp;
        Please Wait
      </span> 
      ) :  (
      <div className='d-flex text-center w-100 align-content-center justify-content-center'>
        {noMatchText ?? ''}
      </div>
      )}
    </div>
    </td>
  </tr>
  )
}